module.exports = __webpack_public_path__ + "img/app_code.bc04fb29.png";